






import { Component, Vue } from 'vue-property-decorator';
import CmsBlock from '@/components/Cms/Block.vue';

@Component({
    components: {
        CmsBlock,
    },
})
export default class CartFooter extends Vue {
    private footerLinks() {
        const activeClass = 'is-active';
        const linkTitles = document.querySelectorAll('.footer.content .link__title');

        if (linkTitles) {
            linkTitles.forEach((linkTitle) => {
                linkTitle.addEventListener('click', () => {
                    if (linkTitle.classList.contains(activeClass)) {
                        linkTitle.classList.remove(activeClass);
                    } else {
                        linkTitles.forEach((element) => element.classList.remove(activeClass));
                        linkTitle.classList.add(activeClass);
                    }
                });
            });
        }
    }

    private mounted() {
        this.footerLinks();
    }
}
